import type { AxiosInstance } from 'axios';
import { cardPaymentSessionSchema, type CardPaymentSession } from '@/schemas/cardPaymentSession';

/**
 * Starts a card payment session; every widget instance gets its own capture context.
 * Sends the page's origin (e.g. `https://app.demo.test`, no path or query) as `url`.
 */
export async function createCardPaymentSessionApi(http: AxiosInstance): Promise<CardPaymentSession> {
  const { data } = await http.post<unknown>('card-payments', { url: window.location.origin });
  const result = cardPaymentSessionSchema.safeParse(data);

  // Zod's own message is meant for developers; the merchant sees this one via the `error` event.
  if (!result.success) {
    throw new Error('Received an invalid payment session.', { cause: result.error });
  }

  return result.data;
}
